var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { FormattedMessage, useIntl, } from 'react-intl';
import { CommandList, defaultKeyboardShortcuts, } from '@folio/stripes/components';
import { Settings, } from '@folio/stripes/smart-components';
import { TitleManager } from '@folio/stripes/core';
var pages = [
    {
        route: 'configuration-options',
        label: React.createElement(FormattedMessage, { id: "ui-mosaic-settings.sections.configuration-options" }),
        component: React.lazy(function () { return import('./ConfigurationOptions'); }),
        perm: 'ui-mosaic-settings.settings.view',
    },
];
export var MosaicIntegrationSettings = function (props) {
    var intl = useIntl();
    return (React.createElement(CommandList, { commands: defaultKeyboardShortcuts },
        React.createElement(TitleManager, { page: intl.formatMessage({ id: 'ui-mosaic-settings.document.settings.title' }) },
            React.createElement(Settings, __assign({}, props, { navPaneWidth: "25%", paneTitle: React.createElement(FormattedMessage, { id: "ui-mosaic-settings.meta.title" }), pages: pages, forceRender: 0 })))));
};
